import React from 'react';
import { useSchema } from '../../../contexts/SchemaContext';

/**
 * IndicatorTypeSelector - Dropdown for selecting indicator types
 * Fetches available indicators from SchemaContext (API-driven)
 */
const IndicatorTypeSelector = ({
  value,
  onChange,
  error,
  disabled = false,
  required = false,
  label = 'Indicator Type',
}) => {
  const { indicatorTypes, loading } = useSchema();

  const handleChange = (e) => {
    onChange(e.target.value);
  };

  if (loading) {
    return (
      <div className="fieldset w-full">
        <label className="label">
          <span className="text-sm">{label}</span>
        </label>
        <select className="select select w-full" disabled>
          <option>Loading indicators...</option>
        </select>
      </div>
    );
  }

  return (
    <div className="fieldset w-full">
      <label className="label">
        <span className="text-sm">{label}{required && <span className="text-error">*</span>}</span>
      </label>
      <select
        className={`select select w-full ${error ? 'select-error' : ''}`}
        value={value || ''}
        onChange={handleChange}
        disabled={disabled}
        required={required}
      >
        <option value="" disabled>Select an indicator</option>
        {Object.entries(indicatorTypes).map(([key, info]) => (
          <option key={key} value={key}>
            {info.label}
            {info.description && ` - ${info.description}`}
          </option>
        ))}
      </select>
      {error && <label className="label"><span className="text-xs text-base-content/60 text-error">{error}</span></label>}
    </div>
  );
};

export default IndicatorTypeSelector;

